<p>view-patient-visit works!</p>
